export const IMAGE_COVER = "rounded-full object-cover"
